let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("12owP")).then(() => parcelRequire('e3A3t'));